import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const ButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: ${rem(4)};
  color: ${({ theme }) => theme.color['gray-600']};
  svg {
    color: ${({ theme }) => theme.color['gray-500']};
  }
`;
